import {useQuery, UseQueryResult} from '@tanstack/react-query';

import {loadLpsAverageRating, loadLpsBenchmarks} from './dashboard-lps-api';
import {DashboardLpsBenchmarksResponseType, DashboardLpsResponseType} from './dashboard-lps-type';

type PropsType = {
    startDate: string;
    endDate: string;
};

export function useLpsAverageRating({startDate, endDate}: PropsType): UseQueryResult<DashboardLpsResponseType> {
    return useQuery(
        [loadLpsAverageRating({startDate, endDate})],
        () =>
            loadLpsAverageRating({
                startDate,
                endDate,
            }),
        {
            retry: 2,
        }
    );
}

export function useLpsBenchmarks(): UseQueryResult<DashboardLpsBenchmarksResponseType> {
    return useQuery(['loadLpsBenchmarks'], () => loadLpsBenchmarks());
}
